<h2 mat-dialog-title>Delete post ‘{{ data.workflowTitle }}‘?</h2>
<mat-dialog-content
  >The post will be deleted permenantly.
  <div class="grid">
    <button
      class="btn btn-secondary input-element button-bottom"
      mat-dialog-close="true"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary input-element button-bottom"
      (click)="deleteWorkflow()"
    >
      Delete post
    </button>
  </div>
</mat-dialog-content>
